import { inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot } from '@angular/router';

import { take } from 'rxjs';

import { PermissionsService } from '@shared/services/permissions.service';
import { PINNED_ITEMS_MAX_LIMIT } from '../constants';
import { PinnedStudiesSitesSignalState } from '../store';

/**
 * @NOTE: PINNED_STUDIES_RESOLVER
 */
export const pinnerStudiesResolver = (
  activateRouteSnapShot: ActivatedRouteSnapshot,
) => {
  const _permissionService = inject(PermissionsService);

  const _isInternal = toSignal(_permissionService.isInternal$.pipe(take(1)));
  const _studiesHomePath = activateRouteSnapShot.pathFromRoot
    .map((m) => m.url)
    .join('/');
  if (_studiesHomePath === '/studies/home' && !_isInternal()) {
    const _pinnedSignalState = inject(PinnedStudiesSitesSignalState);
    _pinnedSignalState.getPinnedItems({
      requestParams: {
        entity_type: 'study',
        limit: PINNED_ITEMS_MAX_LIMIT,
        offset: 0,
        sort_by: 'NEWEST',
      },
    });
    return !!_pinnedSignalState.$data() && !_pinnedSignalState.$isLoading();
  }
  return false;
};

/**
 * @NOTE: PINNED_SITES_RESOLVER
 */
export const pinnedSitesResolver = (
  activatedRouteSnapShot: ActivatedRouteSnapshot,
) => {
  const _permissionService = inject(PermissionsService);

  const _isInternal = toSignal(_permissionService.isInternal$.pipe(take(1)));
  const _sitesHomePath = activatedRouteSnapShot.pathFromRoot
    .map((m) => m.url)
    .join('/');
  if (_sitesHomePath === '/sites/home' && !_isInternal()) {
    const _pinnedSignalState = inject(PinnedStudiesSitesSignalState);
    _pinnedSignalState.getPinnedItems({
      requestParams: {
        entity_type: 'site',
        limit: PINNED_ITEMS_MAX_LIMIT,
        offset: 0,
        sort_by: 'NEWEST',
      },
    });
    return !!_pinnedSignalState.$data() && !_pinnedSignalState.$isLoading();
  }
  return false;
};
